/**
 * Constantes de viewport del editor — alineadas con portal/backoffice.
 * Subconjunto mínimo para reproducción web (escapeRoomViewportAutoLayout).
 */

export const CANVAS_WIDTH = 960;
export const CANVAS_HEIGHT = 540;

export const DESKTOP = { width: CANVAS_WIDTH, height: CANVAS_HEIGHT };

export const VIEWPORTS = [
	{ id: "desktop", width: 960, height: 540 },
	{ id: "tablet", width: 768, height: 540 },
	{ id: "mobile", width: 360, height: 780 },
];

export const PLAY_HUD_RESERVED_ZONE_HEIGHT = {
	desktop: 52,
	tablet: 52,
	mobile: 52,
};

export function getPlayHudReservedZoneHeight(viewportId) {
	return PLAY_HUD_RESERVED_ZONE_HEIGHT[viewportId] ?? PLAY_HUD_RESERVED_ZONE_HEIGHT.desktop;
}
